<h2 mat-dialog-title i18n>Firma erstellen/bearbeiten</h2>
<div mat-dialog-content data-testid="company-edit-dialog">
  <form [formGroup]="form" class="form-grid">
    <mat-form-field appearance="fill">
      <mat-label i18n>Firmenname</mat-label>
      <input
        matInput
        formControlName="companyName"
        data-testid="company-name-input"
      />
      @if (form.get("companyName")?.errors?.["required"]) {
        <mat-error i18n>Firmenname ist erforderlich</mat-error>
      }
      @if (form.get("companyName")?.errors?.["minlength"]) {
        <mat-error i18n
          >Firmenname muss mindestens 2 Zeichen lang sein</mat-error
        >
      }
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label i18n>Ansprechperson</mat-label>
      <input
        matInput
        formControlName="contactPersonName"
        data-testid="contact-person-name-input"
      />
      @if (form.get("contactPersonName")?.errors?.["required"]) {
        <mat-error i18n>Ansprechperson ist erforderlich</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Email</mat-label>
      <input
        matInput
        type="email"
        formControlName="email"
        data-testid="email-input"
      />
      @if (data?.company && !emailEditingEnabled) {
        <button
          class="hover:cursor-pointer"
          matSuffix
          mat-button
          type="button"
          (click)="enableEmailEditing()"
          matTooltip="EMail Adresse überschreiben. "
          i18n-matTooltip
          i18n
        >
          <mat-icon>edit</mat-icon>
        </button>
      }
      @if (form.get("email")?.errors?.["required"]) {
        <mat-error i18n>Email ist erforderlich</mat-error>
      }
      @if (form.get("email")?.errors?.["email"]) {
        <mat-error i18n>Bitte geben Sie eine gültige Email ein</mat-error>
      }
      @if (form.get("email")?.errors?.["emailTaken"]) {
        <mat-error i18n>Diese Email wird bereits verwendet</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>UID</mat-label>
      <input matInput formControlName="uid" data-testid="uid-input" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label i18n>Webseite</mat-label>
      <input matInput formControlName="website" data-testid="website-input" />
      @if (form.get("website")?.errors?.["required"]) {
        <mat-error i18n>Webseite ist erforderlich</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label i18n>Telefon</mat-label>
      <input matInput formControlName="phone" data-testid="phone-input" />
      @if (form.get("phone")?.errors?.["required"]) {
        <mat-error i18n>Telefon ist erforderlich</mat-error>
      }
    </mat-form-field>

    <div formGroupName="address" class="address-grid">
      <mat-form-field appearance="fill">
        <mat-label i18n>Straße und Nr.</mat-label>
        <input
          matInput
          formControlName="streetAndNumber"
          data-testid="street-and-number-input"
        />
        @if (
          form.get("address")?.get("streetAndNumber")?.errors?.["required"]
        ) {
          <mat-error i18n>Straße und Nr. ist erforderlich</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label i18n>Stadt</mat-label>
        <input matInput formControlName="city" data-testid="city-input" />
        @if (form.get("address")?.get("city")?.errors?.["required"]) {
          <mat-error i18n>Stadt ist erforderlich</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label i18n>PLZ</mat-label>
        <input
          matInput
          formControlName="postalCode"
          data-testid="postal-code-input"
        />
        @if (form.get("address")?.get("postalCode")?.errors?.["required"]) {
          <mat-error i18n>PLZ ist erforderlich</mat-error>
        }
      </mat-form-field>
    </div>

    <mat-form-field appearance="fill" class="col-span-2">
      <mat-label>Kategorien</mat-label>
      <mat-select
        formControlName="categoryIds"
        multiple
        data-testid="category-ids-select"
      >
        @for (category of availableCategories; track category) {
          <mat-option [value]="category.id">{{ category.name }}</mat-option>
        }
      </mat-select>
      @if (form.get("categoryIds")?.errors?.["required"]) {
        <mat-error i18n>Mindestens eine Kategorie ist erforderlich</mat-error>
      }
    </mat-form-field>

    <div class="col-span-2">
      <mat-chip-set>
        @for (categoryId of form.get("categoryIds")?.value; track categoryId) {
          <mat-chip>{{ getCategoryName(categoryId) }}</mat-chip>
        }
      </mat-chip-set>
    </div>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" i18n>Abbrechen</button>
  <button
    class="button-blue"
    (click)="save()"
    [disabled]="form.invalid"
    i18n
    data-testid="edit-company-save-button"
  >
    Speichern
  </button>
</div>
